import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./hiredProvider.css";

const HiredProvider = ({ project_id, interestedProviders }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div onClick={() => setShowModal(true)} className="hire-card">
                <div className="hire-card-left">
                    <div className="hire-card-image">
                        <img src="/assets/images/New-files/hire-not-ico-a.svg" alt="hire icon" />
                    </div>
                </div>
                <div className="hire-card-right">
                    <div className="hire-card-text">Have you hired a provider?</div>
                    <div className="hire-card-button">
                        <span className="button-text">Pick a Provider</span>
                        <img className="arrow-icon" src="/assets/icon/button/arrow-right-dark.svg" alt="arrow" />
                    </div>
                </div>
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-inner">
                            {interestedProviders.length > 0 && (
                                <>
                                    <Link 
                                        to={`/select_hired/${project_id}`} 
                                        onClick={() => setShowModal(false)} 
                                        className="primary-button"
                                    >
                                        Select from a provider who has reached out to you
                                    </Link>
                                    <div className="divider"></div>
                                </>
                            )}
                            
                            <Link 
                                to={`/close_project/${project_id}`} 
                                onClick={() => setShowModal(false)} 
                                className="secondary-button"
                            >
                                Hired someone else outside the Platform
                            </Link>

                            <div className="info-box">
                                <span className="info-icon">
                                    <img alt="info" src="/assets/images/New-files/information-circle-outline.png" />
                                </span>
                                <span className="info-text">
                                    For this project, in case you have already hired a provider of your choice outside of the EasyBids platform, kindly confirm.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HiredProvider;